import {isEmpty, isNil} from 'ramda';

export const isSomething = (anything) => !isNil(anything) && !isEmpty(anything);
